'use strict';

var d3 = require('d3');
var _ = require('lodash');

var d3InterpolatePath = require('d3-interpolate-path');
//var d3InterpolateChromatic = require('d3-scale-chromatic')

var drawUtils = require('../utils/drawUtils');
var toolTipHandler = require('../utils/toolTipHandler');

var d3CHS = {};

d3CHS.initCHS = function (svg, header, params, onCohortUpdate) {

	d3CHS.svg = svg;
	svg.append('text').attr('id', 'cohort-container-header').attr('font-size', 16).attr('font-weight', 400).attr('x', 16).attr('y', -params.top + 32).text(header);

	d3CHS.onCohortUpdate = onCohortUpdate;

	d3CHS.onDraged = false;

	// select div for the tooltip
	d3CHS.toolTip = d3.select("#tooltip").style("opacity", 0);
	d3CHS.toolTip.minimal = d3CHS.toolTip.select('#minimal');
	d3CHS.toolTip.minimal.pointer = d3CHS.toolTip.minimal.select('#pointer');
	d3CHS.toolTip.minimal.htmlContent = d3CHS.toolTip.minimal.select('#htmlContent');
};

d3CHS.updateCHS = function (svg, props, params, nCohort, tweenTime) {

	//console.log('props cohorts :',props)

	d3CHS.tweenTime = tweenTime;
	d3CHS.cohorts = props.cohorts;

	// set temp bin ==> will be cleaned 
	d3CHS.cohorts.binData = _.clone(props.column.categories);

	_.each(d3CHS.cohorts, function (d, i) {

		d3CHS.setDimensions(d, props, params, nCohort, i);
	});

	//console.log(d3CHS.cohorts);

	var cohorts = d3CHS.svg.selectAll('#gCohort').data(d3CHS.cohorts, function (d, i) {
		return i;
	});

	cohorts.enter().append('g').attr('id', 'gCohort').attr("transform", function (d, i) {
		return "translate(" + d.x + "," + d.y + ")";
	}).each(function (d, i) {
		var g = d3.select(this);

		svg.append('circle').attr('id', 'cohort-base-dot-' + i).attr('r', 3).attr('stroke', '#fff').attr('cx', d.pVertex.x).attr('cy', d.pVertex.y);

		g.append('text').attr('id', 'cohort-header-title').attr('x', -16).attr('y', 24).attr('font-size', 14).attr('font-weight', 400).attr('text-anchor', 'end').text(d.header);

		g.append('text').attr('id', 'cohort-header-metric').attr('x', -16).attr('y', 40).attr('font-size', 12).attr('font-weight', 200).attr('text-anchor', 'end').text('n= ' + d.nPatients + ' | ' + (d.perc * 100).toFixed(2) + '%');

		d3CHS.updateCirclePack(g, d, i);
	});

	cohorts.transition().duration(d3CHS.tweenTime).attr("transform", function (d, i) {
		return "translate(" + d.x + "," + d.y + ")";
	}).each(function (d, i) {
		var g = d3.select(this);

		svg.select('#cohort-base-dot-' + i).transition().duration(d3CHS.tweenTime).attr('cx', d.pVertex.x).attr('cy', d.pVertex.y);

		g.select('#cohort-header-metric').text('n= ' + d.nPatients + ' | ' + (d.perc * 100).toFixed(2) + '%');

		d3CHS.updateCirclePack(g, d, i);
	});

	cohorts.exit().remove();

	d3CHS.updateBin(params);
};

d3CHS.setDimensions = function (d, props, params, nCohort, cohortIndex) {

	d.cohortIndex = cohortIndex;
	d.rMedian = params.height / 4;
	d.nPatients = 0;
	d.nCohort = nCohort;

	d.colorScheme.palette = drawUtils.generatePallete(d.colorScheme.type, d.colorScheme.range, d.categories.length + 1);

	var defaultColor = drawUtils.generatePallete(d.colorScheme.type, d.colorScheme.range, 1);
	d.colorScheme.defaultColor = defaultColor[0];

	d.cpData = {};

	d.cohortPatients = [];

	_.each(d.categories, function (category) {

		var o = _.find(props.column.categories, function (c) {
			return c.category === category;
		});
		if (o) {
			d.cpData[category] = o;
			d.cohortPatients = d.cohortPatients.concat(o.patients);
		}

		if (d3CHS.cohorts.binData[category]) delete d3CHS.cohorts.binData[category];
	});

	d.nPatients = d.cohortPatients.length;
	d.perc = d.nPatients / d.nCohort;
	d.r = params.height / 2 * d.perc;
	d.wh = params.height * d.perc;

	d.x = params.width - d.r * 2 - 40;
	d.y = cohortIndex * (params.height / 2);
	if (cohortIndex > 0) {
		d.x = d3CHS.cohorts[cohortIndex - 1].x + (d3CHS.cohorts[cohortIndex - 1].wh - d.wh) / 2;
		d.y = d3CHS.cohorts[cohortIndex - 1].y + d3CHS.cohorts[cohortIndex - 1].wh;
	}

	d.cp = { x: d.x + d.r, y: d.y + d.r };
	d.pVertex = { x: d.x + d.r * 2, y: d.y + d.r };

	//d.colorScheme.interpolator = d3.scaleSequential().domain([0, 16]).interpolator(d3InterpolateChromatic['interpolate'+drawUtils.colors.interpolators[cohortIndex]]);
};

d3CHS.updateBin = function (params) {

	var hBin = 48;
	var binData = {
		cohortIndex: -1,
		nPatients: 0,
		categories: [],
		height: hBin,
		x: -params.rXY,
		y: params.height + params.top - hBin + params.rXY,
		width: params.width + params.rXY,

		pVertex: { x: params.width, y: params.height + params.top - hBin + params.rXY + hBin / 2, cohortIndex: -1 }

	};

	_.each(d3CHS.cohorts.binData, function (c) {
		c.cohortIndex = -1;
		binData.nPatients += c.patients.length;
		binData.categories.push(c);
	});

	d3CHS.cohorts.binData = binData;

	var gBin = d3CHS.svg.selectAll('#gBin').data([d3CHS.cohorts.binData]);

	gBin.enter().append('g').attr('id', 'gBin').attr("transform", function (d, i) {
		return "translate(" + d.x + "," + d.y + ")";
	}).attr('visibility', function (d) {
		return d.categories.length > 0 ? "visible" : "hidden";
	}).each(function (d, i) {
		var g = d3.select(this);

		g.append('rect').attr('id', 'bin-bckgr').attr('width', params.width + params.rXY).attr('height', d.height).attr("rx", params.rXY).attr("ry", params.rXY).attr('fill', '#f6f6f6');

		g.append('circle').attr('id', 'bin-pVertex').attr('r', 2).attr("cx", d.width).attr("cy", d.height / 2).attr('fill', '#666');

		g.append('svg:foreignObject').attr("width", 32).attr("height", 32).attr('y', d.height / 2 - 11).attr('x', 32).attr('opacity', 0.75).append("xhtml:body").style('cursor', 'default').html('<i class="iconfont-dls-16"></i>');

		var offset = { x: d.x, y: d.y };
		d3CHS.updateBinCategories(g, d.categories, i, d.height, offset);
	});

	gBin.attr('visibility', function (d) {
		return d.categories.length > 0 ? "visible" : "hidden";
	}).each(function (d, i) {
		var g = d3.select(this);

		var offset = { x: d.x, y: d.y };
		d3CHS.updateBinCategories(g, d.categories, i, d.height, offset);
	});
};

d3CHS.updateBinCategories = function (_g, data, index, height, offset) {

	var binCategory = _g.selectAll('#gCategory').data(data, function (d, i) {
		d.data = { id: d.label, size: d.patients.length };
		d.x = 100 + i * 32;
		d.y = height / 2 - 2;
		d.class = 'leaf';
		d.r = 12;
		d.offset = offset;
		d.fill = '#ccc';

		return d.category;
	});

	binCategory.enter().append('g').attr('id', 'gCategory').attr("transform", function (d, i) {
		return "translate(" + d.x + "," + d.y + ")";
	}).attr('cursor', 'grab').each(function (d) {

		var g = d3.select(this);

		g.append('circle').attr('r', d.r).attr('fill', d.fill);

		g.append('text').attr('text-anchor', 'middle').attr('alignment-baseline', 'middle').attr('font-size', 10).attr('font-weight', 400).attr('cursor', 'grab').text(d.label);
	}).on('mouseover', function (d) {
		d3CHS.showToolTip(d);
	}).on('mousemove', function () {
		d3CHS.toolTipPosition();
	}).on('mouseout', function (d) {
		d3CHS.removeToolTip();
	}).call(d3.drag().subject(function (d) {
		return { x: d.x, y: d.y };
	}).on("start", function (d) {
		d3CHS.onDraged = true;
		var g = d3.select(this);
		d3CHS.onDragStart(g, d, 'start', d3.event, d.cohortIndex);
	}).on("drag", function (d) {
		var g = d3.select(this);
		d3CHS.onDrag(g, d, 'drag', d3.event, d.cohortIndex);
	}).on("end", function (d) {
		d3CHS.onDraged = false;
		d3CHS.removeToolTip();
		var g = d3.select(this);
		d3CHS.onDragEnd(g, d, 'end', d3.event, d.cohortIndex);
	}));

	binCategory.attr("transform", function (d, i) {
		return "translate(" + d.x + "," + d.y + ")";
	});

	binCategory.exit().remove();
};

d3CHS.getP0vertex = function (cohortIndex) {

	var vertex = null;
	if (cohortIndex >= 0) {
		vertex = d3CHS.cohorts[cohortIndex].pVertex;
	} else {
		vertex = { x: d3CHS.cohorts.binData.pVertex.x, y: d3CHS.cohorts.binData.pVertex.y };
	}

	vertex.cohortIndex = cohortIndex;

	return vertex;
};

d3CHS.getCohortColor = function (cohortIndex, value) {

	//console.log(value)

	if (cohortIndex < 0) return drawUtils.colors.similarPatients.deSelected;

	if (!value) return d3CHS.cohorts[cohortIndex].colorScheme.defaultColor;

	return d3CHS.cohorts[cohortIndex].colorScheme.palette[value];
};

d3CHS.updateCirclePack = function (_g, column, cohortIndex) {

	d3CHS.svg.select('#cohort-base-dot-' + cohortIndex).attr('fill', column.colorScheme.defaultColor);

	var packData = {
		id: 'root',
		children: []
	};

	_.each(column.cpData, function (d) {
		var o = {
			id: d.category,
			size: d.patients.length
		};
		packData.children.push(o);
	});

	var rPack = column.r * 2;
	var pack = function pack(data) {
		return d3.pack().size([rPack, rPack]).padding(3)(d3.hierarchy(data).sum(function (d) {
			return d.size;
		}).sort(function (a, b) {
			return b.size - a.size;
		}));
	};

	d3CHS.updateNodes(_g, pack(packData), cohortIndex);
};

d3CHS.updateNodes = function (_g, root, cohortIndex) {

	var nodes = _g.selectAll("g").data(root.descendants(), function (d, i) {
		d.class = !d.children ? "leaf" : d.depth ? "" : "root";

		d.opacity = 1;
		d.label = d.data.id;
		d.fill = d3CHS.getCohortColor(cohortIndex, i);

		d.cohortIndex = cohortIndex;
		d.offset = { x: d3CHS.cohorts[cohortIndex].x, y: d3CHS.cohorts[cohortIndex].y };

		if (d.class == 'root') {
			d.opacity = 0.25;
			d.label = '';
			d.fill = d3CHS.getCohortColor(cohortIndex, 1);
		}
		return d.data.id;
	});

	nodes.enter().append("g").attr("transform", function (d) {
		return "translate(" + d.x + "," + d.y + ")";
	}).attr("class", function (d) {
		return d.class;
	}).attr('cursor', function (d) {
		return d.class === 'leaf' ? "grab" : "default";
	}).each(function (d, i) {
		var g = d3.select(this);

		g.append("circle").attr("id", "node-" + d.class).attr("r", d.r).style("fill", d.fill).style('fill-opacity', d.opacity);

		g.append('text').attr('class', 'legend-label').style('fill', '#fff').attr('text-anchor', 'middle').attr('alignment-baseline', 'middle').attr('font-size', 10).text(d.label);
	}).on('mouseover', function (d) {
		d3CHS.showToolTip(d);
	}).on('mousemove', function () {
		d3CHS.toolTipPosition();
	}).on('mouseout', function (d) {
		d3CHS.removeToolTip();
	}).call(d3.drag().subject(function (d) {
		return { x: d.x, y: d.y };
	}).on("start", function (d) {
		d3CHS.onDraged = true;
		var g = d3.select(this);
		d3CHS.onDragStart(g, d, 'start', d3.event, d.cohortIndex);
	}).on("drag", function (d) {
		var g = d3.select(this);
		d3CHS.onDrag(g, d, 'drag', d3.event, d.cohortIndex);
	}).on("end", function (d) {
		d3CHS.onDraged = false;
		d3CHS.removeToolTip();
		var g = d3.select(this);
		d3CHS.onDragEnd(g, d, 'end', d3.event, d.cohortIndex);
		//console.log('drag end')
	}));

	nodes.transition().duration(d3CHS.tweenTime).attr("transform", function (d) {
		return "translate(" + d.x + "," + d.y + ")";
	}).each(function (d, i) {
		var g = d3.select(this);

		g.select("#node-" + d.class).transition().duration(d3CHS.tweenTime).attr("r", d.r).style("fill", d.fill).style('opacity', d.opacity);
	});

	nodes.exit().remove();
};

d3CHS.onDragStart = function (_g, d, type, event, cohortIndex) {

	if (d.class !== 'leaf') return;

	_g.attr('opacity', 0.15);

	d3CHS.dragedCircle = d3CHS.svg.append('g').attr("id", 'drag-circle').attr("transform", "translate(" + (event.x + d.offset.x) + "," + (event.y + d.offset.y) + ")").attr('cursor', 'grab');

	d3CHS.dragedCircle.append("circle").attr("r", d.r).style("fill", d.fill).style('opacity', d.opacity);

	d3CHS.dragedCircle.append('text').attr('class', 'legend-label').style('fill', '#fff').attr('text-anchor', 'middle').attr('alignment-baseline', 'middle').attr('font-size', 10).text(d.label);
};

d3CHS.onDrag = function (_g, d, type, event, cohortIndex) {

	if (d.class !== 'leaf') return;
	d3CHS.dragedCircle.attr("transform", "translate(" + (event.x + d.offset.x) + "," + (event.y + d.offset.y) + ")");

	var cohortUpdate = d3CHS.pointInCohort(event, d, cohortIndex);

	var fill = d.fill;
	var stroke = 'none';
	if (cohortUpdate.type === 'remove') {
		fill = '#ccc';
		stroke = drawUtils.colors.signals.warning;
	}

	d3CHS.dragedCircle.select('circle').style('fill', fill).style('stroke', stroke);
};

d3CHS.onDragEnd = function (_g, d, type, event, cohortIndex) {

	if (d.class !== 'leaf') return;

	_g.attr('opacity', d.opacity);
	d3.selectAll('#drag-circle').remove();

	var cohortUpdate = d3CHS.pointInCohort(event, d, cohortIndex);

	console.log(cohortUpdate);

	if (cohortUpdate.update) {
		d3CHS.onCohortUpdate(cohortUpdate);
	};
};

d3CHS.pointInCohort = function (event, d, cohortIndex) {

	if (cohortIndex === undefined) return;

	var drag = { x: event.x + d.offset.x, y: event.y + d.offset.y };
	var cohorts = d3CHS.svg.selectAll('#gCohort');

	var cohortUpdate = { update: true, type: 'remove', category: d.data };

	cohorts.each(function (cohort, i) {
		var inCircle = false;

		if (cohort.r === 0) cohort.r = d.r;

		var distancesquared = (drag.x - cohort.cp.x) * (drag.x - cohort.cp.x) + (drag.y - cohort.cp.y) * (drag.y - cohort.cp.y);
		if (distancesquared <= cohort.r * cohort.r) {

			inCircle = true;
			cohortUpdate.update = false;
			cohortUpdate.type = 'none';

			if (i !== cohortIndex) {
				//console.log('in cohort :',cohort.header);
				cohortUpdate.update = true;
				cohortUpdate.type = 'update';
				cohortUpdate['cohort'] = cohort;
			}
		}
	});

	return cohortUpdate;
};

d3CHS.showToolTip = function (d) {

	if (d3CHS.onDraged) return;
	if (d.data.id === 'root') return;

	var label = '<span style="font-size:14px; font-weight:400;" >' + d.data.id + ': ' + d.data.size + '</span><br>';
	toolTipHandler.addMinimalContent(label, d3CHS.toolTip);
	d3CHS.toolTipPosition();
};

d3CHS.toolTipPosition = function () {
	toolTipHandler.position(d3CHS.toolTip, d3.event);
};

d3CHS.removeToolTip = function (globalClick) {
	toolTipHandler.remove(d3CHS.toolTip);
};

module.exports = d3CHS;